import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[150px] w-full bg-white border border-[#e1e1e1] rounded-mob-4 lg:rounded-web-6 sm:rounded-tab-4 outline-none px-mob-17 lg:px-web-20 sm:px-tab-17 py-mob-12 lg:py-web-12 sm:py-tab-12 text-mob-16 sm:text-tab-16 lg:text-web-20 focus:outline-[1px] focus:border-none focus:outline-gray-400 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
